import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatTableModule} from '@angular/material/table';
import { MainContainerComponent } from '../shared/main-container/main-container.component';
import { TableComponent } from './table/table.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import { LoaderComponent } from './loader/loader.component';
import { FormsModule } from '@angular/forms';
@NgModule({
  providers: [],
  declarations: [
    MainContainerComponent,
    TableComponent,
    LoaderComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule
  ],
  exports: [
    MainContainerComponent,
    TableComponent,
    LoaderComponent
  ]
})
export class SharedModule { }
